import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxGalleryAnimation } from 'ngx-gallery';
import { MenuTypeService } from '../../core/services/menu-type.service';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';
import { firebase } from '@firebase/app';
import { ContentsMandatory } from '../../core/models/contents-mandatory';
import { DragulaService } from 'ng2-dragula/ng2-dragula';
import { FileUpload } from '../../core/models/fileupload';
import { ExtraService } from '../../core/services/extra.service';

@Component({
  selector: 'app-header-image-slider',
  templateUrl: './header-image-slider.component.html',
  styleUrls: ['./header-image-slider.component.css'],
  viewProviders: [DragulaService, MenuTypeService]
})
export class HeaderImageSliderComponent implements OnInit {

  categoryName: string;
  cName: string;
  cmListArray = new Array<string>();

  eventId: string;
  eventSlider: boolean = true;
  currentFiles = [];
  currentFileUpload: FileUpload;
  uploadFileName: string = null;
  uploadprogress: number = null;
  images: string[] = new Array();

  tagName = 'dragId';

  @ViewChild("FileUpload") fileUploader;

  constructor(private extraService: ExtraService, private dragula: DragulaService, private confirmationService: ConfirmationService, private menuTypeService: MenuTypeService) {
    const bag: any = this.dragula.find(this.tagName);
    if (bag !== undefined) this.dragula.destroy(this.tagName);
    this.dragula.setOptions(this.tagName, {});
  }

  ngOnInit() {
    console.log(this.cName)
    console.log(this.eventId)

    //if (this.categoryName == 'image' || this.categoryName == 'video') {
    //this.images = new Array();
    //} else {
    if (this.cmListArray) {
      for (let i = 0; i < this.cmListArray.length; i++) {
        if (this.cmListArray[i]) {
          this.menuTypeService.getContentMendatoryMenuIdData(this.cmListArray[i], this.eventId).subscribe((conMan) => {
            if (conMan) {
              this.images[i] = conMan.fileUrl;
            }
          });
        }
      }
      //}
    }


    this.dragula.drop.subscribe(value => {
      this.onDrop(value.slice(1));
    });

  }

  private onDrop(args) {
    let [e] = args;
    let sourceIndex = +e.getAttribute('item-index');
    let targetIndex = this.getElementIndex(e);
    this.swapData(sourceIndex, targetIndex);
  }

  swapData(index: number, index2: number) {
    let temp = this.cmListArray[index];
    if (index2 > index) {
      for (let i = index; i < index2; i++) {
        this.cmListArray[i] = this.cmListArray[i + 1];
      }
    } else {
      for (let i = index; i > index2; i--) {
        this.cmListArray[i] = this.cmListArray[i - 1];
      }
    }
    this.cmListArray[index2] = temp;
  }

  private getElementIndex(el: any) {
    return [].slice.call(el.parentElement.children).indexOf(el);
  }

  _ref: any;
  onBasicUpload(event) {
    this.currentFiles = event.files;
    for (let file of event.files) {

      this.extraService.setMenuTypeSubmit(false);
      this.currentFileUpload = new FileUpload(file);
      let uploadTask = this.menuTypeService.pushUploadMenu(this.currentFileUpload, this.eventId, this.cName);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
        (snapshot) => {
          this.uploadprogress = Math.floor((uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100);
        },
        (error) => {
        },
        () => {
          // upload success
          let contentsMandatory = new ContentsMandatory();
          contentsMandatory.category = this.cName;
          contentsMandatory.eventId = this.eventId;
          contentsMandatory.filename = file.name;
          contentsMandatory.sizeInBytes = file.size;
          contentsMandatory.extension = file.name.split('.').pop();
          contentsMandatory.fileUrl = uploadTask.snapshot.downloadURL;
          this.images.push(uploadTask.snapshot.downloadURL);
          let key = this.menuTypeService.addMenuDetails(contentsMandatory, contentsMandatory.eventId);
          if (key) {
            this.cmListArray.push(key);
            console.log(this.cmListArray);

          }
          this.extraService.setMenuTypeSubmit(true);
        });
      setTimeout(() => {
        this.fileUploader.files = new Array();
      }, 5000);
    }
  }

  deleteImage(event) {
    console.log('currentFiles', this.currentFiles.length);
    this.uploadFileName = null;
    this.uploadprogress = null;
  }

  deleteSliderImage(index) {
    this.images = this.images.filter((val, i) => i != index);
    //this.cmListArray = this.cmListArray.filter((val, i) => i != index);
    if (this.cmListArray.length == 1) {
      this.cmListArray.pop();
      console.log(this.cmListArray)
    } else {
      let data: string;
      for (let i = index; i < this.cmListArray.length - 1; i++) {
        data = this.cmListArray[i];
        this.cmListArray[i] = this.cmListArray[i + 1];
        this.cmListArray[i + 1] = data;
      }
      console.log(this.cmListArray);
      this.cmListArray.pop();
      console.log(this.cmListArray);
    }
  }

}




// WEBPACK FOOTER //
// /workspace/backend-server/src/app/layout/header-image-slider/header-image-slider.component.ts